<template>
  <div>
    <PageTitle
      title="Kitchen Stocks"
      :btnCreate="true"
      
    />
    

    <v-container fluid class="lighten-12 content">
      <!-- Page Title -->
      <v-card class="lighten-12 card-content">
        <TableFilters
          :filters="['product', 'search']"
          v-model="filter"
          :columns="columns"
        >
        </TableFilters>
      </v-card>

      <v-card class="mt-2">
        <v-container fluid class="light gray lighten-12">
          <!-- Data Table -->
          <v-row>
            <v-card-text class="pa-0">
              <v-data-table
                :items-per-page="paginationOptions.perPage"
                :fixed-header="true"
                :headers="headers"
                :items="KitchenStocks"
                item-key="name"
                hide-default-footer
               
              >
             <template v-slot:item.available_stock="{ item }">
                  <v-chip
                    :x-small="true"
                    class="ma-2"
                    label
                    text-color="white"
                    :color="getStockColor(item)"
                    dark
                    >{{ item.available_stock }}</v-chip
                  >
                </template>

                <template v-slot:no-data>
                  <div class="mt-16 container justify-center item-center">
                    <img
                      style="height: 200px"
                      src="../../../assets/img/no-result.jpg"
                    />
                  </div>
                </template>

                ]

                <template v-slot:footer>
                  <pagination
                    @paginationOptions="setPaginationOptions"
                    @response="setResponseData"
                    url="hms/kitchen-stocks"
                    :filter="filter"
                    ref="pagination"
                  />
                </template>

              

              

            
              </v-data-table>
            </v-card-text>
          </v-row>
        </v-container>
      </v-card>
      <!-- </v-card> -->
      <div class="d-flex justify-center align-center"></div>
    </v-container>
  </div>
</template>

<script>
import { required, email, max } from "vee-validate/dist/rules";
import pagination from "../../shared/components/pagination";
import confirmation from "../../shared/components/confirmation";

import { Guest } from "../../../models/Guest";

import _ from "lodash";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
import TableFilters from "@/components/base/TableFilters";
extend("required", {
  ...required,
  message: "{_field_} is required",
});

extend("max", {
  ...max,
  message: "{_field_} may not be greater than {length} characters",
});

extend("email", {
  ...email,
  message: "Email must be valid",
});

export default {
  data: () => ({
    paginationOptions: {},
    expanded: [],
    singleExpand: false,
    pagination1: {
      descending: true,
      page: 1,
      rowsPerPage: 2,

      sortBy: "fat",
      totalItems: 0,
      rowsPerPageItems: [1, 2, 4, 8, 16],
    },

    pagination: {
      page: 1,
      itemsPerPage: 2,
    },
    page: 1,
    
    columns: [
      {
        text: "Product",
        value: "product.name",
        show: true,
        disabled: false,

        width: "14%",
      },
       {
        text: "Product Code",
        value: "product.code",
        show: true,
        disabled: false,

         width: "14%",
      },

      {
        text: "Amount",
        value: "amount",
        show: true,
        disabled: false,
        width: "14%",
      },
      {
        text: "Unit",
        value: "unit.name",
        show: true,
         width: "14%",
        disabled: false,
      },
       {
        text: "Available Stock",
        value: "available_stock",
        show: true,
         width: "14%",
        disabled: false,
      },
      {
        text: "Damage",
        value: "damage",
        show: true,
        disabled: false,
         width: "14%",
      },
      {
        text: "Missing",
        value: "missing",
        show: true,
        disabled: false,
         width: "14%",
      },
      {
        text: "Kitchen",
        value: "kitchen.name",
        show: true,
         width: "14%",
        disabled: false,
      },

    
     
    ],

    KitchenStocks: [],
    filter: {
      name: "",
      search: "",
    
    },
  }),
  components: {
    TableFilters,
    ValidationProvider,
    ValidationObserver,
    pagination,
  },

  methods: {
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    refreshData() {
      this.$refs.pagination.refreshData();
    },

    setResponseData(data) {
      
      this.KitchenStocks = data;
    },

    getStatusColor(status) {
      return status ? "green" : "gray";
    },

     getFoodColor(status) {
       
      return status ? "green" : "red";
    },
     getStockColor(stock) {
      console.log(stock);
      if (
        0 < stock.available_stock &&
        stock.available_stock < stock.reorder_level
      ) {
        return "orange";
      } else if (stock.available_stock < 1) {
        return "red";
      } else {
        return "green";
      }
    },
    clearFilter() {
      this.filter = {};
    },
  },
   filters: {
    hasName: function (value) {
      
      if (has(value, "name")) return value.name;
      else return "-";
    },
  },
  computed: {
    // Filter - return selected table fields
    headers: function() {
      return this.columns.filter((item) => item.show == true);
    },
  },
};
</script>
